<template>
    <div>
    <Modal
        class-name="vertical-center-modal"
        :value="showSetModel"
        :title="$t('detail')"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'600px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80" >
             <FormItem :label="$t('BasicProduct.funcBox.titleName.Min')" prop="Min" style="width: 500px">
                <Input type="number" v-model="formData.Min"  ></Input>
            </FormItem>


            <FormItem :label="$t('BasicProduct.funcBox.titleName.Max')" prop="Max" style="width: 500px">
                <Input type="number" v-model="formData.Max" ></Input>
            </FormItem>

           
            
            <FormItem :label="$t('BasicProduct.funcBox.titleName.Decimals')" prop="Decimals" style="width: 500px">
                <Input type="number" v-model="formData.Decimals" ></Input>
            </FormItem>
            
            <FormItem :label="$t('BasicProduct.funcBox.titleName.Step')" prop="Step" style="width: 500px">
                <Input type="number" v-model="formData.Step" ></Input>
            </FormItem>
            
            <FormItem v-if="DataType==7" :label="$t('BasicProduct.funcBox.titleName.Multiple')" prop="Multiple" style="width: 500px">
                <Input type="number" v-model="formData.Multiple" ></Input>
            </FormItem>
            
            <!-- <FormItem v-if="DataType==7" :label="$t('BasicProduct.funcBox.titleName.Negative')" prop="Negative" style="width: 500px">
                <RadioGroup v-model="formData.Negative">
                     <Radio label="Y">
                         <span>Y</span>
                     </Radio>
                     <Radio label="N">
                         <span>N</span>
                     </Radio>
                 </RadioGroup>
            </FormItem> -->
            
            <FormItem :label="$t('BasicProduct.funcBox.titleName.Unit-CN')" prop="Unit-CN" style="width: 500px">
                <Input type="text" v-model="formData['Unit-CN']" ></Input>
            </FormItem>
            <FormItem :label="$t('BasicProduct.funcBox.titleName.Unit-EN')" prop="Unit-EN" style="width: 500px">
                <Input type="text" v-model="formData['Unit-EN']" ></Input>
            </FormItem>
            
            <FormItem :label="$t('BasicProduct.funcBox.titleName.LanguageKey')" prop="LanguageKey" style="width: 500px">
                <Input type="text" v-model="formData.LanguageKey"  ></Input>
            </FormItem>
            
          
        </Form>

    </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showSetModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import { mapState } from 'vuex'

    export default {
        props: {
            showSetModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object,
            languageKey:Object,
            DataType:String,
            initdata:[Array ,Object],
            isGener:{
                type:Boolean,
                default:false
            }
        },
        name: "Model5",
        data() {
            return {   
                disabled: false,//禁用确定按钮
                formData: {
                   Max:'',
                   Min:'',
                   Decimals:'',
                   Step:'',
                   Multiple:'',
                   Negative:'',
                   'Unit-CN':"",
                   'Unit-EN':"",
                   LanguageKey:''
                }
               
            }
        },
        computed:{
            ...mapState(['local','selectId']),
             ruleCustom(){
                 return {//验证
                   
                }
             } 

        },
        created(){
           
        },
        methods: {
        
          
            openOrClose(value) {
                if(value === true) {
                   
                    if(Array.isArray(this.editFormData.IndentyName)){
                        this.formData = {...this.editFormData.IndentyName[0]}
                    }

                    if(Object.prototype.toString.call(this.editFormData.IndentyName)=='[object Object]'){

                        this.formData=  {...this.editFormData.IndentyName}
                    }
                }  
            },
            cancel() {//对话框关闭
                this.$emit('update:showSetModel',false);
                this.resetForm()
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>

<style lang="less" scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
.delButton {
    /deep/ .ivu-form-item-content {
    margin-left: 20px !important;
}
}
</style>

